const CHECK_CT_CA_ONFLY_INIT = 'OVID/CHECKORDERCTONFLY/CHECK_CT_CA_ONFLY_INIT'
const CHECK_CT_CA_ONFLY_SUCCESS = 'OVID/CHECKORDERCTONFLY/CHECK_CT_CA_ONFLY_SUCCESS'
const CHECK_CT_CA_ONFLY_FAILED = 'OVID/CHECKORDERCTONFLY/CHECK_CT_CA_ONFLY_FAILED'

export const constants = {
  CHECK_CT_CA_ONFLY_INIT,
  CHECK_CT_CA_ONFLY_SUCCESS,
  CHECK_CT_CA_ONFLY_FAILED,
}
